import React from "react";
import { FormControlLabel, styled, Switch, Theme } from "@material-ui/core";
import { AppSwitchProps } from "./app-switch.types";
import { SwitchProps } from "@material-ui/core";

const SwitchUI = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(
  ({
    theme,
    size,
    color,
  }: {
    theme: Theme;
    size: "small" | "medium";
    color?: "primary" | "secondary";
  }) => ({
    width: size === "small" ? 45 : 53,
    height: size === "small" ? 24 : 28,
    padding: 0,
    margin: "0 5px",
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: "0 3px",
      transitionDuration: "300ms",
      top: "50%",
      transform: "translateY(-50%)",
      "&.Mui-checked": {
        transform: `translate(${size === "small" ? 21 : 25}px, -50%)`,
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor:
            color === "secondary"
              ? "var(--secondary-color)"
              : "var(--accent-color)",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.grey[100],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.7,
        backgroundColor: "var(--field-bg)",
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: size === "small" ? 18 : 21,
      height: size === "small" ? 18 : 21,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: "var(--field-bg)",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }),
);

const AppSwitchComponent: React.FC<AppSwitchProps> = ({
  label,
  size = "small",
  labelPlacement = "start",
  color = "primary",
  labelColor,
  ...switchProps
}) => {
  return (
    <FormControlLabel
      label={label}
      style={{
        color:
          labelColor ??
          (color === "primary"
            ? "var(--secondary-text)"
            : "var(--primary-text)"),
      }}
      className="text-capitalize p-0 m-0"
      labelPlacement={labelPlacement}
      control={<SwitchUI size={size} color={color} {...switchProps} />}
    />
  );
};

export default AppSwitchComponent;
